// The only users who see the Download SME review (Excel) buttons: Melanie Lowenkamp
// and Wes Hodges. The exportSmeReview / exportPyiSmeReview callables enforce the same
// list (SME_REVIEW_USER_IDS in praxusbackend) — keep the two in step.
export const SME_REVIEW_USER_IDS: readonly string[] = ['RbxDoBJaYtUjwilVAPka46PZy8c2', 'powN4oyEY1NOZaUgyO7IRFY5fbJ2'];

export function isSmeReviewUser(userId: string | undefined | null): boolean {
  return !!userId && SME_REVIEW_USER_IDS.includes(userId);
}
